import Vue from 'vue'
import router from './router'
import store from './store'
import meta from './libs/meta'
import vuetify from './libs/vuetify'
import base from './mixins/base'
import App from './App'
import '@/assets/css/globals/_index.scss'

Vue.mixin(base)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  meta,
  render: h => h(App)
}).$mount('#app')
